import React, { useState } from 'react';
import { Container } from '../../../components';
import FileUploadTemplate from '@/components/common/FileUpload/FileUploadTemplate';
import { usePaymentReminder } from '@/context/paymentReminderContext/PaymentReminderContextProvider';

const UpdateEmail = () => {
  const [selectedFiles, setSelectedFiles] = useState([]);

  const { loadEmailFileAPI } = usePaymentReminder();
  const handleFilesSelected = (files) => {
    if (files.length !== 1) {
      alert('Please upload exactly one file.');
      return;
    }
    setSelectedFiles(files);
  };
  const handleUpload = async (files) => {
    if (files.length === 1) {
      await loadEmailFileAPI(files[0]);
      setSelectedFiles([]); // Clear selected files after successful upload
    } else {
      alert('Please select a file to upload.');
    }
  };
  return (
    <Container title="Update Email">
      <div className="p-2">
        {' '}
        <h2 className="text-2xl font-semibold text-gray-800 mb-4"></h2>
        <p className="text-gray-500 mb-6 text-center">
          Please upload a xlsx file containing Email data.
        </p>
        <FileUploadTemplate
          acceptedFileTypes={['.xlsx', '.xls']}
          onFilesSelected={handleFilesSelected}
          multiple={false}
          onUpload={handleUpload}
          maxFiles={1}
        />
        <div className="overflow-x-auto rounded-lg bg-gray-50 shadow-sm">
          <table className="min-w-full divide-y divide-gray-200 text-sm text-gray-700">
            <thead className="bg-gray-100">
              <tr>
                <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                  Customer Code{' '}
                </th>
                <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                  Email{' '}
                </th>
                <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                  {' '}
                  Customer Name
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {/* Sample Row */}
              <tr>
                <td className="py-2 px-4 text-center">XY0121</td>
                <td className="py-2 px-4 text-center">ABEFG@domain.com</td>
                <td className="py-2 px-4 text-center">Dummy Company</td>
              </tr>
              {/* Additional rows can be added here */}
            </tbody>
          </table>
        </div>
      </div>
    </Container>
  );
};

export default UpdateEmail;
